import React from 'react';
import { Pin, X } from 'lucide-react';

export const MessengerPinnedStrip = ({ message, previewText, onClear }) => {
  if (!message) return null;

  return (
    <div data-testid="pinned-message-strip" style={{ padding: '10px 14px 4px' }}>
      <div style={{ borderRadius: 20, border: '1px solid var(--card-border)', background: 'var(--pinned-surface)', padding: '10px 12px', display: 'flex', alignItems: 'flex-start', gap: 10 }}>
        <div style={{ width: 34, height: 34, borderRadius: '50%', background: 'var(--surface)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Pin size={16} color="var(--accent-purple)" />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ margin: 0, fontFamily: "'Inria Serif', serif", fontSize: 14, fontWeight: 700, color: 'var(--text)' }}>Pinned message</p>
          <p data-testid="pinned-message-preview" style={{ margin: '2px 0 0', fontFamily: "'Inria Serif', serif", fontSize: 15, color: 'var(--text-2)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{previewText}</p>
        </div>
        <button type="button" data-testid="pinned-message-clear-button" onClick={onClear} style={{ width: 30, height: 30, borderRadius: '50%', border: 'none', background: 'var(--surface)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 }}>
          <X size={16} color="var(--text-2)" />
        </button>
      </div>
    </div>
  );
};